import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import API, { createAxiosHeaders } from "../utils/api";
import "./gallery.css";
import logo from '../karuncup.svg';

const GalleryPage = () => {
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    API.get("/api/gallery/", createAxiosHeaders())
      .then(res => setItems(res.data))
      .catch(err => console.log(err))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen w-full bg-black text-white relative overflow-hidden">

      {/* BACKGROUND GLOW */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#052700] to-black opacity-40 pointer-events-none"></div>
      <div className="neon-circle"></div>

      {/* ---------------- HEADER ---------------- */}
      <header className="flex flex-col px-6 md:px-16 py-6 relative z-20">
        <div className="flex items-center justify-between border-b py-4">

          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            className="flex items-center gap-3"
          >
            <img
              src={logo}
              alt="Karun Cup Logo"
              className="h-14 w-12 object-contain neon-logo"
            />
          </motion.div>

          <motion.button
            whileHover={{ scale: 1.1 }}
            onClick={() => (window.location.href = "/")}
            className="px-6 py-2 neon-border bg-lime-500 text-black rounded-xl text-lg font-semibold hover:bg-lime-300 transition"
          >
            بازگشت
          </motion.button>
        </div>

        <h1 className="mt-8 text-2xl mx-auto text-center md:text-3xl font-bold neon-text">
          آلبوم دوره‌های پیشین جشنواره کارون‌کاپ
        </h1>
      </header>

      {/* ---------------- LOADING ---------------- */}
      {loading && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="flex flex-col items-center justify-center py-32"
        >
          <svg
            className="animate-spin h-12 w-12 text-lime-400 mb-4"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
            ></path>
          </svg>

          <p className="text-gray-300 text-lg">در حال بارگذاری...</p>
        </motion.div>
      )}

      {/* ---------------- GALLERY GRID ---------------- */}
      {!loading && (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-7 px-6 md:px-20 py-16 relative z-10">
          {items.map((item, index) => (
            <motion.div
              key={item.id || index}
              whileHover={{ scale: 1.05, rotateZ: 1 }}
              className="relative cursor-pointer overflow-hidden rounded-2xl album-card"
              onClick={() => setSelected(item.image)}
            >
              <motion.img
                src={item.image}
                initial={{ opacity: 0, scale: 1.1 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5 }}
                className="w-full h-64 object-cover album-img"
              />
              <div className="album-overlay"></div>
            </motion.div>
          ))}
        </div>
      )}

      {/* ---------------- LIGHTBOX ---------------- */}
      {selected && (
        <motion.div
          className="fixed inset-0 bg-black/80 backdrop-blur-md flex items-center justify-center z-50"
          onClick={() => setSelected(null)}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
        >
          <motion.img
            src={selected}
            className="max-w-3xl w-[90%] rounded-2xl neon-img"
            initial={{ scale: 0.7, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: "spring", stiffness: 130 }}
          />
        </motion.div>
      )}

    </div>
  );
};

export default GalleryPage;
